import "./base.js";
import "./navigation/navigation_button.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};

const __NavigationPrior = AppointmentBooking.Wizard.Views.Navigation;
AppointmentBooking.Wizard.Views.Navigation = class Navigation extends AppointmentBooking.Wizard.Views.Base {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.setButtonText = this.setButtonText.bind(this);
    this.enable = this.enable.bind(this);
    this.disable = this.disable.bind(this);
    this.showButton = this.showButton.bind(this);
    this.hideButton = this.hideButton.bind(this);
    this.toggleButton = this.toggleButton.bind(this);
    this.enableButton = this.enableButton.bind(this);
    this.disableButton = this.disableButton.bind(this);
    this.holdButton = this.holdButton.bind(this);
    this.resumeButton = this.resumeButton.bind(this);
  }

  initialize() {
    this.buttons = {};
    this.buttons.back = new AppointmentBooking.Wizard.Views.NavigationButton({
      name: "back",
      text: this.I18n().navigation.back,
    });
    return (this.buttons.continue = new AppointmentBooking.Wizard.Views.NavigationButton({
      name: "continue",
      text: this.I18n().navigation.continue,
    }));
  }

  // RENDERING

  render() {
    super.render(...arguments);
    this.replaceContents(
      ".navigation-buttons-container",
      this.buttons.continue.render().el,
      this.buttons.back.render().el,
    );
    return this;
  }

  // DSL

  setButtonText(buttonName, text) {
    return this.buttons[buttonName].setText(text);
  }

  enable() {
    this.buttons.back.enable();
    return this.buttons.continue.enable();
  }

  disable() {
    this.buttons.back.disable();
    return this.buttons.continue.disable();
  }

  showButton(buttonName) {
    return this.buttons[buttonName].show();
  }

  hideButton(buttonName) {
    return this.buttons[buttonName].hide();
  }

  toggleButton(buttonName, state = !this.buttons[buttonName].isEnabled()) {
    return this.buttons[buttonName].toggle(state);
  }

  enableButton(buttonName) {
    return this.buttons[buttonName].enable();
  }

  disableButton(buttonName) {
    return this.buttons[buttonName].disable();
  }

  holdButton(buttonName) {
    return this.buttons[buttonName].hold();
  }

  resumeButton(buttonName, state = true) {
    return this.buttons[buttonName].resume(state);
  }
};
AppointmentBooking.Wizard.Views.Navigation.prototype.tagName = "div";
AppointmentBooking.Wizard.Views.Navigation.prototype.template = "navigation";
AppointmentBooking.Wizard.Views.Navigation.prototype.className = "appointment-booking-wizard-navigation";
AppointmentBooking.Wizard.Views.Navigation.prototype.events = { "click .navigation-button": "handleButtonClick" };
if (__NavigationPrior) {
  Object.assign(AppointmentBooking.Wizard.Views.Navigation, __NavigationPrior);
}
